export const REQUEST_VALIDATE_INVITATION = "REQUEST_VALIDATE_INVITATION";
export const GRANT_VALIDATE_INVITATION = "GRANT_VALIDATE_INVITATION";
export const REVOKE_VALIDATE_INVITATION = "REVOKE_VALIDATE_INVITATION";
export const RESET_VALIDATE_INVITATION = "RESET_VALIDATE_INVITATION";
